export { VolumesStrategy } from './Volumes'
export { DetailedVolumeStrategy } from './DetailedVolume'
